module.exports = __webpack_public_path__ + "img/name.13e87bb2.svg";